class VideoOverlay extends HTMLElement {
    constructor() {
        super()
        this.videoButton = null
        this.videoOverlay = null
        this.closeButton = null
    }

    connectedCallback() {
        this.videoButton = this.querySelector("#video-button")
        this.videoOverlay = this.querySelector("#video-overlay")
        this.closeButton = this.querySelector("#close-button")
        this.video = this.querySelector("video")

        if (this.videoButton && this.videoOverlay && this.closeButton) {
            this.videoButton.addEventListener("click", () => this.showOverlay())
            this.closeButton.addEventListener("click", () => this.hideOverlay())
            // this.videoOverlay.addEventListener("click", () => this.hideOverlay())
        }
    }

    showOverlay() {
        this.video.currentTime = 0
        this.videoOverlay.classList.add("active")
        document.body.style.overflow = "hidden"
    }

    hideOverlay() {
        this.video.pause()
        this.videoOverlay.classList.remove("active")
        document.body.style.overflow = ""
    }
}

customElements.define("video-banner", VideoOverlay)
